import { useMemo } from "react";

import { useTranslation } from "next-i18next";

import { MerchantType } from "@/Apollo/schema";
import { MerchantUnknown } from "@/common/contracts/merchant.contracts";

export const useMerchantName = (
  merchant?: MerchantUnknown | null,
  hide = true
) => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!merchant) {
      return t("common:common-unknown");
    }

    if (!hide && merchant.name) {
      return merchant.name;
    }

    if (merchant.type === MerchantType.Individual) {
      return t("common:common-info-private-seller");
    }

    if (merchant.type === MerchantType.Business) {
      return t("common:common-info-business-seller");
    }
  }, [hide, merchant, t]);
};
